/*
    Used to take an array collection and mapping and create
    a new collection of objects.

    @function zipFunc
    @param {Array} mappings
    @param {Array} collection
    @returns {Array} - a mapped collection
*/
function zipFunc(mappings, collection) {
    return collection.map(function resultMap(item) {
        return item.reduce(function resultReduce(obj, value, i) {
            obj[mappings[i]] = value;

            return obj;
        }, {});
    });
}

/*
    Used to take a mapped collection and convert it back
    to an Array of arrays.

    Example Return
    {
        mappings: [],
        collection: [[]]
    }

    @function unzip
    @param {Array} collection
    @param {Array} [mappings]
    @returns {Object}
*/
function unzipFunc(collection, mappings) {
    if(!mappings) {
        mappings = collection.reduce(function reduceCollection(arr, item) {
            Object.keys(item).forEach(function forEachKey(key) {
                if(!~arr.indexOf(key)) {
                    arr.push(key);
                }
            });

            return arr;
        }, [])
        .sort();
    }

    var arrCollection = collection.map(function mapCollection(item) {
        return mappings.reduce(function reduceKeys(arr, key) {
            arr.push(item[key]);

            return arr;
        }, []);
    });

    return {
        mappings: mappings,
        collection: arrCollection
    };
}



module.exports = {
    zip: zipFunc,
    unzip: unzipFunc
};
